import React from 'react';

import './WorkplaceRetirementBalanceDisclosure.scss';

import TRP from 'components/shared/TRP/TRP';
import { hasExternalRPSAccount } from 'services/Accounts';

const WorkplaceRetirementBalanceDisclosure = ({ accounts }) => {
  const showDisclosureStatement = accounts.some(hasExternalRPSAccount);

  return (
    <>
      {showDisclosureStatement && (
        <div className="balance-disclosure">
          Workplace retirement balance does not include{' '}
          <span className="no-wrap">
            non-
            <TRP />
          </span>{' '}
          investments.
        </div>
      )}
    </>
  );
};

export default WorkplaceRetirementBalanceDisclosure;
